import React from 'react';
import { useTranslation } from 'react-i18next';
import { LazyImage } from '@/components/ui/LazyImage';
const HeroSection = () => {
  const { t } = useTranslation();
  const handleImageLoad = () => {
    // Defer analytics tracking to not block rendering with browser compatibility check
    const trackAnalytics = () => {
      if (window.gtag) {
        window.gtag('event', 'view_hero', {
          event_category: 'Engagement',
          event_label: 'Hero Section View',
          send_to: 'G-GT45QQEG2R'
        });
      }
    };

    // Use requestIdleCallback if available, otherwise fallback to setTimeout
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(trackAnalytics);
    } else {
      setTimeout(trackAnalytics, 0);
    }
  };
  return <section className="relative w-full min-h-0 flex items-center justify-center overflow-hidden bg-hero-gradient py-6 md:py-10 lg:py-14">
      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 flex flex-col md:flex-row items-center justify-center md:gap-6 lg:gap-10 pt-14 md:pt-8 gap-6">
        <div className="flex-1 md:flex-none md:w-1/2 max-w-2xl">
          <div className="mx-[15px] sm:mx-[50px]">
            <h1 className="sm:text-5xl md:text-6xl lg:text-8xl font-sans leading-tight mb-6 md:mb-8 text-stone-800 tracking-tight text-4xl font-medium">
              SUMSAE
              <span className="sr-only"> — High-Performance K-Beauty Skincare Backed by Science</span>
            </h1>
            <p className="sm:text-lg md:text-xl lg:text-2xl text-stone-600 font-inter font-normal tracking-widest uppercase leading-relaxed text-sm">
              High-Performance Skincare<br />
              Backed by Science
            </p>
          </div>
        </div>
        
        {/* Beauty Image - Optimized loading */}
        <div className="flex-1 md:flex-none md:w-1/2 flex justify-center">
          <div className="w-full max-w-[18rem] sm:max-w-sm md:max-w-sm lg:max-w-md" style={{ aspectRatio: '2/3' }}>
            <img 
              src="https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/model3_3.webp" 
              alt="Korean skincare beauty" 
              onLoad={handleImageLoad} 
              loading="eager"
              fetchPriority="high"
              decoding="sync"
              className="object-scale-down w-full h-full" 
              width="512" 
              height="768"
              style={{ aspectRatio: '2 / 3' }}
            />
          </div>
        </div>
      </div>
    </section>;
};
export default React.memo(HeroSection);